import { Controller } from "@hotwired/stimulus"

/*
 * フッターボタンエリアの表示制御コントローラー
 * - スクロールで画面最下部に到達したら非表示にする
 * - モーダル表示中は非表示にする
 *   （.footer-btn の z-index は Bootstrap のモーダルより手前のため、隠さないとモーダルに重なる）
 */

// Connects to data-controller="fixed-footer-button"
export default class extends Controller {
  // モーダル表示中はスクロールによる再表示を抑止するためのフラグ
  private isModalOpen = false

  // bind() は毎回新しい関数を返すため、removeEventListener で同一参照を渡せるよう保持する
  private readonly boundHandleScroll = this.handleScroll.bind(this)
  private readonly boundHandleModalShow = this.handleModalShow.bind(this)
  private readonly boundHandleModalHidden = this.handleModalHidden.bind(this)

  // コントローラーの接続時の処理
  connect(): void {
    window.addEventListener('scroll', this.boundHandleScroll)
    // モーダルのイベントは modal 要素で発火し document まで伝播する
    document.addEventListener('show.bs.modal', this.boundHandleModalShow)
    document.addEventListener('hidden.bs.modal', this.boundHandleModalHidden)
  }

  // コントローラーの切断時の処理
  disconnect(): void {
    window.removeEventListener('scroll', this.boundHandleScroll)
    document.removeEventListener('show.bs.modal', this.boundHandleModalShow)
    document.removeEventListener('hidden.bs.modal', this.boundHandleModalHidden)
  }

  /**
   * モーダルが開いたらフッターボタンエリアを非表示にする
   */
  private handleModalShow(): void {
    this.isModalOpen = true
    this.element.classList.add('is_hide')
  }

  /**
   * モーダルが閉じたらスクロール位置に応じた表示状態へ戻す
   */
  private handleModalHidden(): void {
    // モーダルが重なっている場合に備え、まだ表示中のモーダルが残っていないか確認する
    // （hidden.bs.modal の時点で、閉じたモーダルからは .show が外れている）
    if (document.querySelector('.modal.show')) return

    this.isModalOpen = false
    this.updateVisibility()
  }

  /**
   * スクロールに応じた表示切替え
   */
  private handleScroll(): void {
    // モーダル表示中は隠したままにする
    if (this.isModalOpen) return

    this.updateVisibility()
  }

  /**
   * フッターボタンエリアの表示切替え(最下部に到達したら非表示)
   */
  private updateVisibility(): void {
    const pageHeight = document.documentElement.scrollHeight
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const windowHeight = window.innerHeight
    const relativePosition = pageHeight - windowHeight - scrollTop

    const BASE_VALUE = 100

    // 下までスクロールすると表示切替え
    if (relativePosition < BASE_VALUE) {
      this.element.classList.add('is_hide')
    } else {
      this.element.classList.remove('is_hide')
    }
  }
}
